import {Description} from '@radix-ui/react-toast';
import clsx from 'clsx';

type Props = React.ComponentPropsWithRef<typeof Description>;
export function ToastDescription(props: Props): React.JSX.Element {
  return (
    <Description
      {...props}
      className={clsx([
        'text-pretty text-sm text-slate11 [grid-area:description]',
        props.className,
      ])}
    />
  );
}

ToastDescription.displayName = 'ToastDescription';
